import { z } from 'zod';

export const migrationStatusSchema = z.object({
  migrated: z.boolean(),
  exists: z.boolean(),
});

export type MigrationStatus = z.infer<typeof migrationStatusSchema>;
